var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('b-row',{staticClass:"text-center"},[_c('b-col',{attrs:{"cols":"8"}},[_c('h1',[_vm._v("About Us")]),_c('h4',[_vm._v("Hello")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }